import { Link } from '@tanstack/react-router';

import { Alert, AlertDescription, AlertTitle } from '@nesso/ui/primitives/alert';

export function SignInWithPasswordInvalidCredentialsAlert() {
    return (
        <Alert variant="destructive">
            <AlertTitle>Incorrect email or password</AlertTitle>
            <AlertDescription className="[&_p]:leading-6">
                <p>
                    Check your spelling and try again, or{' '}
                    <Link to="/forgot-password" className="underline underline-offset-4">
                        reset your password
                    </Link>
                    .
                </p>
            </AlertDescription>
        </Alert>
    );
}
